import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../models/stores/Root';
import Header from '../../components/framework/Header';
import Footer from '../../components/framework/Footer';
import Divider from '../../components/content/Divider';
import CartSummarySection from '../../components/framework/CartSummarySection';
import CheckoutPageContainer from '../../components/framework/CheckoutPageContainer';
import GuestCheckoutView from '../views/GuestCheckoutView';

const GuestCheckoutPage: React.FC = observer(() => {
  const rootStore = useMst();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { configuration, cart, customer, currentStep } = rootStore;

  const checkoutDivRef = useRef<HTMLDivElement>(null);

  const {
    stripeInfo: { clientSecretKey: stripeClientSecretKey },
  } = cart;

  const scrollTopOfPage = (): void => {
    if (checkoutDivRef.current?.scrollIntoView) {
      checkoutDivRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (currentStep === 'Guest.WalletValidation') {
      rootStore.sendWalletValidationEvent();
    }
  });

  const handleLoginSuccess = async (): Promise<void> => {
    await rootStore.loadCustomerFlow();
    rootStore.send({ type: 'USER_LOGIN', customer: customer.customerData });
  };

  return (
    <CheckoutPageContainer cart={<CartSummarySection />} ref={checkoutDivRef}>
      <Header
        logoText={configuration.logo.text ?? ''}
        logoPublicId={configuration.logo.publicId ?? undefined}
      />
      <Divider className="md:hidden" />
      <GuestCheckoutView
        stripeClientSecretKey={stripeClientSecretKey || undefined}
        onLoginSuccess={handleLoginSuccess}
        onScrollTopOfPage={scrollTopOfPage}
      />
      <Footer
        showTermsAndConditions={rootStore.stateMatches('Guest.Payment')}
      />
    </CheckoutPageContainer>
  );
});

export default GuestCheckoutPage;
